export const Emblem = ({ className = "h-10 w-9", strokeWidth = 2.4 }) => (
  <svg viewBox="0 0 120 132" className={className} fill="none" aria-label="LexAegis G&P emblem">
    <path
      d="M60 6 L106 23 V60 C106 90 86 110 60 124 C34 110 14 90 14 60 V23 Z"
      stroke="currentColor"
      strokeWidth={strokeWidth}
    />
    <path
      d="M60 14 L98 28 V60 C98 85 82 102 60 114 C38 102 22 85 22 60 V28 Z"
      stroke="currentColor"
      strokeWidth="0.75"
      opacity="0.55"
    />
    <circle cx="60" cy="35" r="2.6" fill="currentColor" />
    <path d="M60 38 V88" stroke="currentColor" strokeWidth="2" />
    <path d="M34 46 H86" stroke="currentColor" strokeWidth="2" />
    <path d="M34 46 L28 60 M34 46 L40 60" stroke="currentColor" strokeWidth="1.4" />
    <path d="M24 60 C24 69 44 69 44 60" stroke="currentColor" strokeWidth="1.6" />
    <path d="M86 46 L80 60 M86 46 L92 60" stroke="currentColor" strokeWidth="1.4" />
    <path d="M76 60 C76 69 96 69 96 60" stroke="currentColor" strokeWidth="1.6" />
    <path d="M48 92 H72 M44 96 H76" stroke="currentColor" strokeWidth="2" />
    <text
      x="60"
      y="110"
      textAnchor="middle"
      fontSize="10.5"
      fontFamily="'Cormorant Garamond', Georgia, serif"
      fontWeight="600"
      letterSpacing="1.5"
      fill="currentColor"
    >
      G&amp;P
    </text>
  </svg>
);
